import { recordEventToHotjar } from "./Hotjar"
import GoogleTagManager from "./GoogleTagManager"
import {
  logInfoToDataDog,
  recordEventToDatadog,
  startSessionReplayRecording,
  stopSessionReplayRecording
} from "./datadog"

export default {
  async sendEvent(eventName, metadata) {
    recordEventToDatadog(eventName, metadata)
    GoogleTagManager.sendGenericEvent({ eventName: eventName, ...metadata })
  },
  sendHotjarEvent(eventName) {
    recordEventToHotjar(eventName)
  },
  async logInfo(eventName, metadata) {
    logInfoToDataDog(eventName, metadata)
  },
  forceSessionReplayRecording() {
    startSessionReplayRecording({ force: true })
  },
  stopSessionReplayRecording() {
    stopSessionReplayRecording()
  }
}
